import { createSlice } from '@reduxjs/toolkit';
import { loginUserAsync, checkAuthAsync } from './authActions';

export function createInitialAuthState() {
  return {
    isAuthenticated: !!localStorage.getItem('token'),
    isCheckingAuth: !!localStorage.getItem('token'),
    user: null, isLoading: false, error: null, authRequestId: null,
  };
}

function resetSession(state) {
  localStorage.removeItem('token');
  state.isAuthenticated = false;
  state.isCheckingAuth = false;
  state.user = null;
  state.isLoading = false;
  state.error = null;
  state.authRequestId = null;
}

const authSlice = createSlice({
  name: 'auth', initialState: createInitialAuthState,
  reducers: { logout: resetSession },
  extraReducers: builder => {
    builder
      .addCase(loginUserAsync.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        state.authRequestId = action.meta.requestId;
      })
      .addCase(loginUserAsync.fulfilled, (state, action) => {
        if (state.authRequestId !== action.meta.requestId) return;
        localStorage.setItem('token', action.payload.token);
        state.isLoading = false;
        state.isCheckingAuth = false;
        state.isAuthenticated = true;
        state.user = { role: action.payload.role, token: action.payload.token };
        state.authRequestId = null;
      })
      .addCase(loginUserAsync.rejected, (state, action) => {
        if (state.authRequestId !== action.meta.requestId) return;
        resetSession(state);
        state.error = action.payload || action.error.message;
      })
      .addCase(checkAuthAsync.pending, (state, action) => {
        state.isCheckingAuth = true;
        state.authRequestId = action.meta.requestId;
      })
      .addCase(checkAuthAsync.fulfilled, (state, action) => {
        if (state.authRequestId !== action.meta.requestId) return;
        if (!localStorage.getItem('token')) { resetSession(state); return; }
        state.isCheckingAuth = false;
        state.isAuthenticated = true;
        state.user = { role: action.payload.role?.name || action.payload.role, details: action.payload };
        state.authRequestId = null;
      })
      .addCase(checkAuthAsync.rejected, (state, action) => {
        if (state.authRequestId !== action.meta.requestId || action.meta.aborted) return;
        resetSession(state);
      });
  },
});

export const { logout } = authSlice.actions;
export const selectIsAuthenticated = state => state.auth.isAuthenticated;
export const selectIsCheckingAuth = state => state.auth.isCheckingAuth;
export const selectUser = state => state.auth.user;
export default authSlice.reducer;
